<template lang="pug">
v-expand-transition
  v-card(dark).sdo-radius.secondary.mb-4(
    style="border: 1px solid #838383 !important; z-index: 22"
  )
    v-card-text.pb-0.px-4.pt-2
      .d-flex.align-center
        h4.white--text Уведомления
        v-btn.ml-auto(
          :disabled="type === TYPES.archive || !notifications.length"
          small color="white" text
          @click="readAll"
        ) Прочитать все
          v-icon(right) mdi-check

      v-list.secondary(outlined max-width="550" max-height="440").overflow-auto.scroll
        v-skeleton-loader(
          v-if="loading"
          type="list-item@3"
        )
        v-list-item(v-else-if="!notifications.length"  outlined)
          v-list-item-content Новых уведомлений не найдено...
        v-slide-x-transition(
          v-for="(n, idx) in notifications"
          :key="idx"
        )
          v-card.sdo-radius.mb-2.secondary.lighten-1(flat)
            v-card-subtitle.white--text.text-caption.d-flex.align-end.py-2
              strong От {{ n.created_at | dp('dd MMMM')}}
              v-spacer
              tooltip-wrap(
                :value="!n.wasRead"
                text="Отметить как прочитанное"
              )
                v-btn(icon small :disabled="n.wasRead" @click="readNotification([n.id])")
                  v-icon {{n.wasRead ? 'mdi-eye-off' : 'mdi-eye' }}
            v-card-text.d-flex.flex-column(v-html="n.message")
    v-divider
    v-btn(
      text block
      :to="{ name: 'Notifications' }"
      @click="$emit('close')"
    ) Показать все

</template>

<script>
export default {
  name: 'NotificationBadgeItems',
  props: {
    notifications: { type: Array, default: () => ([]) },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      type: 0,
      TYPES: {
        all: 0,
        archive: 1,
      },
    };
  },
  watch: {
    type(val) {
      this.$emit('update', val);
    },
  },
  methods: {
    async readAll() {
      await this.$api.notifications.readAllNotification();
      this.$emit('update', this.type);
    },
    readNotification(ids) {
      const payload = {
        ids,
      };
      this.$api.notifications.readNotification(payload);
      this.$emit('read', ids);
    },
  },
};
</script>
